import React, { PropsWithChildren, useEffect } from "react";
import AppHeader from "../components/Header";
import Lnb from "components/Lnb";

import styled from "styled-components";
import { device } from "../components/styles";
import { useLocation } from "react-router-dom";
import NavigationBar from "components/Common/NavigationBar/NavigationBar";
import MobileHeader from "components/Header/MobileHeader";
import useIsMobile from "hooks/useIsMobile";
import Footer from "components/Common/Footer/Footer";
import { useBanner } from "hooks/useBanner";
import { getIsUser } from "utils/utility";
import "../styles/scrollbar.css";

const DefaultLayout = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const { fetchBanners } = useBanner();
  const isUser = getIsUser();

  // 로그인된 사용자가 있고 배너 데이터가 없으면 가져오기
  useEffect(() => {
    if (isUser) {
      fetchBanners();
    }
  }, [isUser, fetchBanners]);

  // 오른쪽 클릭 & ctrl+c 차단
  useEffect(() => {
    const preventContextMenu = (e: MouseEvent) => e.preventDefault();
    const preventCopyShortcut = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "c") {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", preventContextMenu);
    document.addEventListener("keydown", preventCopyShortcut);

    return () => {
      document.removeEventListener("contextmenu", preventContextMenu);
      document.removeEventListener("keydown", preventCopyShortcut);
    };
  }, []);

  return (
    <Root>
      {!pathname.startsWith("/signup") &&
        (isMobile ? (
          !pathname.startsWith("/data-room/detail") && <MobileHeader />
        ) : (
          <AppHeader />
        ))}
      <ContentWrap>
        {!pathname.startsWith("/signup") && !pathname.startsWith("/mypage") && (
          <Lnb />
        )}
        <div className={pathname.startsWith("/mypage") ? "mypage" : ""}>
          {children}
        </div>
      </ContentWrap>
      <Footer />
      {!pathname.startsWith("/signup") && <NavigationBar />}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fafafa;

  @media all and (${device.mobile}) {
    width: 100vw;
  }
`;

export const ContentWrap = styled.div`
  display: flex;
  align-items: stretch;
  width: 100vw;
  max-width: 1440px;
  min-height: calc(100vh - 6.2rem);
  margin: 0 auto;
  flex-grow: 1;
  > div:not(.lnb) {
    padding-top: 6.2rem;
    width: calc(100% - 320px);
    margin: 0 auto;
    &.mypage {
      width: 100%;
    }
  }

  @media all and (${device.mobile}) {
    > div:not(.lnb) {
      width: 100%;
      padding-top: 5.8rem;
    }
    padding: 0 0 13rem;
  }
`;

export default DefaultLayout;
